import React from 'react';

const FormError = ({ error }) => (
  <span className="onboarding-subheader_error">{error}</span>
);

export default FormError;



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/components/CustomerDesign/FormError.js